// Robust tier mapping (handles "BASIC", "basic_plan", " Standard ", etc.)
export function getTierLevel(tierStr: string | undefined | null): number {
  if (!tierStr) return 0;
  const t = tierStr.toString().trim().toUpperCase();
  if (t.includes("PREMIUM")) return 3;
  if (t.includes("STANDARD")) return 2;
  if (t.includes("BASIC")) return 1;
  return 0;
}

export function isSubscriptionActive(user: any): boolean {
  if (!user) return false;

  const tier = (user.subscription?.tier || user.role || "")
    .toString()
    .trim()
    .toUpperCase();
  if (!tier || tier === "FREE" || tier === "USER") return false;

  const status = (
    user.subscriptionStatus ||
    user.subscription?.status ||
    ""
  ).toUpperCase();
  if (status === "EXPIRED" || status === "CANCELED" || status === "CANCELLED")
    return false;

  const expiresAt =
    user.subscriptionExpiresAt ||
    user.subscription?.expiresAt ||
    user.subscription?.currentPeriodEnd ||
    user.subscription?.endsAt;
  if (expiresAt) {
    const t = new Date(expiresAt).getTime();
    if (!Number.isNaN(t) && t < Date.now()) return false;
  }
  return true;
}
